<template>

  <svg
    t="1631088970598"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4940"
    width="64"
    height="64"
  ><path d="M851.39152593 983.8592c-56.43377778 29.85528889-125.12521482 8.73813333-155.10186667-45.63247408-22.9376-42.11294815-15.89854815-94.66311111 14.07810371-128.03792592l-44.05475556-82.40545185c-22.9376 7.03905185-45.8752 10.55857778-70.51188148 10.55857777-109.22666667 0-199.15662222-77.18684445-216.75425185-178.76764444h-91.62903705c-15.89854815 43.81202963-58.13285925 75.3664-107.52758517 75.3664-63.47282963 0-114.56663703-50.85108148-114.56663704-113.95982223s51.09380741-113.95982222 114.56663704-113.95982222c49.39472592 0 91.62903703 29.85528889 107.52758517 73.66731852h93.4494815c19.41807408-99.88171852 109.22666667-173.54903703 216.75425184-173.54903703 17.59762963 0 35.19525925 1.69908148 51.09380741 5.2186074l37.0157037-87.62405925c-35.19525925-31.55437037-47.57428148-82.40545185-28.1562074-127.91656297 24.63668148-57.89013333 91.62903703-85.92497778 149.76189629-61.40965925 58.13285925 24.51531852 86.41042963 91.14358518 61.65238519 149.03371852-19.41807408 45.63247408-63.47282963 71.84687408-109.22666666 70.14779258l-38.83614815 91.1435852c58.13285925 38.59342222 96.96900741 105.22168889 96.9690074 178.76764443 0 66.62826667-31.67573333 126.21748148-79.37137778 166.50998519l44.05475556 82.40545185c45.8752-7.03905185 93.44948148 15.77718518 118.08616297 57.89013333 28.27757037 52.67152592 7.16041482 122.81931852-49.27336297 152.55324445z m0 0" p-id="4941" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconRelation',
} as DefineComponent
</script>